import React, { useEffect, useState } from "react";

// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  Link,
  Text,
  useColorModeValue,
  SimpleGrid,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Stack,
  Alert,
  AlertIcon,
  IconButton
} from "@chakra-ui/react";

// Custom components
import HistoryItem from "views/admin/testProducts/components/HistoryItem";
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import { useListContext } from '../../../contexts/listContext';
import { useProductStore } from "../../../store/useProductStore";
import Loader from "../../../components/loader/Loader"
import { MdViewList, MdViewModule, MdCheckCircle, MdCancel, MdDelete, MdShoppingCart, MdOutlineError } from "react-icons/md";



import Card from "components/card/Card.js";
import PurchaseHistory from "./components/PurchaseHistory";



export default function Products() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  // Chakra Color Mode
  const [abuseCulprit, setAbuseCulprit] = useState([]);
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorBrand = useColorModeValue("brand.500", "white");
  const userInfo = JSON.parse(localStorage.getItem('PAuser'));
  const isAdmin = userInfo?.message?.isAdmin || false;
  const [isLoading, setIsLoading] = useState(false)

  const [productsToShow, setProductsToShow] = useState(20); // Initial number of products to show
  const productsPerPage = 20; // Number of products to load per page
  const [sortedProducts, setSortedProducts] = useState([]);
  const [statusUpdate, setStatusUpdate] = useState(false);
  const [viewMode, setViewMode] = useState("grid")



  const [productByStatus, setProductByStatus] = useState([]);
  const [testProducts, setTestProducts] = useState([]);
  const [insertSeller, setInsertSeller] = useState([]);
  const [fetchedProducts, setFetchedProducts] = useState([]);
  const { list, checkedPlatforms, dateFilter } = useListContext();
  const [alertTimeout, setAlertTimeout] = useState(null);

  const [successAlert, setSuccesAlert] = useState('');
  const [failureAlert, setFailureAlert] = useState('');

  const { products, moveProducts, updateProducts } = useProductStore();


  useEffect(() => {
    return () => {
      if (alertTimeout) {
        clearTimeout(alertTimeout);
      }
    };
  }, [alertTimeout]);

  const handleSuccessAlert = async (alertMessage) => {
    if (alertTimeout) {
      clearTimeout(alertTimeout);
    }
    setSuccesAlert(alertMessage);
    const timeout = setTimeout(() => {
      setSuccesAlert("");
    }, 5000);
    setAlertTimeout(timeout);
  };

  const handleFailureAlert = async (alertMessage) => {
    if (alertTimeout) {
      clearTimeout(alertTimeout);
    }
    setFailureAlert(alertMessage);
    const timeout = setTimeout(() => {
      setFailureAlert("");
    }, 5000);
    setAlertTimeout(timeout);
  };

  const fetchProductsByStatus = async (status) => {
    try {
      setIsLoading(true)
      const response = await fetch(`${backendUrl}/api/products/byStatus`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          uid: userInfo?.message?.result.id,
          status: status
        })
      });

      const json = await response.json();

      if (response.ok) {
        updateProducts(json, "testPurchase");
      } else if (response.status === 400) {
        //console.log(json);
        handleFailureAlert("Error fetching products");
      }
    } catch (e) {
      handleFailureAlert("Error fetching products");

    } finally {
      setIsLoading(false)

    }
  };

  useEffect(() => {
    if (!products["testPurchase"]) {
      fetchProductsByStatus("T");
    } else {
      setSortedProducts(products["testPurchase"]);
    }
  }, [userInfo?.message?.result.id]);


  const loadMore = () => {
    setProductsToShow(productsToShow + productsPerPage);
  };
  const loadLess = () => {
    setProductsToShow(productsToShow - productsPerPage);
  };

  const handleUpdateProduct = async (psm_id, test_purchase_status) => {
    try {
      const existingIndex = testProducts.findIndex(item => item.psm_id === psm_id);
      if (existingIndex !== -1) {
        // Product already exists, update its status
        setTestProducts(prev => {
          const updatedProd = [...prev];
          updatedProd[existingIndex].test_purchase_status = test_purchase_status;
          return updatedProd;
        });
      } else {
        // Product does not exist, add it to the list
        setTestProducts([...testProducts, { psm_id, test_purchase_status }]);
      }
      //console.log('testProducts', testProducts);
    } catch (err) {
      console.error('err in handleInserSeller', err)
    }
  }


  const removeProductFromUpdate = async (psm_id, test_purchase_status) => {
    setTestProducts(testProducts.filter((item) => {
      return !(item.psm_id === psm_id && item.test_purchase_status === test_purchase_status);
    }));
    //console.log('removed from list', testProducts);
  }

  const handleUpdateSeller = async (product, seller_status) => {
    try {
      const existingIndex = insertSeller.findIndex(item => item.product.psm_id === product.psm_id);

      if (existingIndex !== -1) {
        // Product already exists, update its status
        setInsertSeller(prev => {
          const updatedSeller = [...prev];
          updatedSeller[existingIndex].seller_status = seller_status;
          return updatedSeller;
        });
      } else {
        // Product does not exist, add it to the list
        setInsertSeller([...insertSeller, { product, seller_status }]);
      }
      //console.log('updateSeller', insertSeller);
    } catch (err) {
      console.error('err in handleInserSeller', err)
    }
  }



  const removeFromUpdate = async (product, seller_status) => {
    setInsertSeller(insertSeller.filter((item) => {
      return !(item.product.psm_id === product.psm_id);
    }));
  }

  const handleInsertAbuse = async (product, abuse_type) => {
    try {
      const existingIndex = abuseCulprit.findIndex(item => item.product.psm_id === product.psm_id);

      if (existingIndex !== -1) {
        // Product already exists, update its status
        setAbuseCulprit(prev => {
          const updated = [...prev];
          updated[existingIndex].abuse_type = abuse_type;
          return updated;
        });
      } else {
        setAbuseCulprit([...abuseCulprit, { product, abuse_type }]);
      }
      //console.log('abused', abuseCulprit);
    } catch (err) {
      console.error('err in handleInserAbuse', err)
    }
  }



  const handleSaveChanges = async () => {
    try {
      setIsLoading(true)

      const response = await fetch(
        `${backendUrl}/api/test/updateStatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            products: testProducts,
          }),
        }
      );
      const json = await response.json();

      if (!response.ok) {
        handleFailureAlert(
          `Error saving changes: ${json.message || "Unknown error"}`
        );
        return;
      }

      for (const item of testProducts) {
        const { psm_id, test_purchase_status } = item;

        if (
          test_purchase_status === 2 ||
          test_purchase_status === 3 ||
          test_purchase_status === 4
        ) {
          await moveProducts("testPurchase", psm_id, "suspicious");
        }
      }
      setSortedProducts(products["testPurchase"]);
      // Update UI state
      setStatusUpdate((prev) => !prev);

      const uid = JSON.parse(localStorage.getItem("PAuser")).message.result.id;
      const response1 = await fetch(
        `${backendUrl}/api/sellers/updateSellerStatus/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            sellers: insertSeller,
            uid: uid,
          }),
        }
      );

      const json1 = await response1.json();

      if (!response1.ok) {
        handleFailureAlert(
          `Error saving changes: ${json1.message || "Unknown error"}`
        );
        return;
      }

      const abuseTypeSave = abuseCulprit;
      const abused = abuseTypeSave.map((item) => ({
        psm_id: item.product.psm_id,
        abuse_type: item.abuse_type,
      }));

      const response2 = await fetch(
        `${backendUrl}/api/products/reportAbuse/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            products: abused,
          }),
        }
      );
      const json2 = await response2.json();
      //console.log("checkpoint", response2);

      if (!response2.ok) {
        handleFailureAlert(
          `Error saving changes: ${json2.message || "Unknown error"}`
        );
        return;
      }

      setTestProducts([]);
      setInsertSeller([]);
      setAbuseCulprit([]);

      setSortedProducts(products["testPurchase"]);

      setStatusUpdate(prev => !prev);

      handleSuccessAlert("Changes Saved Successfully");
    } catch (e) {
      //console.log("error in handleSavechanges");
      handleFailureAlert("Error saving changes. Please try again");

    } finally {
      setIsLoading(false)

    }
  }

  const handleSearch = async (text) => {
    try {
      // setProducts(fetchedProducts);
      if (text) {
        setSortedProducts(products["testPurchase"].filter((item) =>
          item.title?.toLowerCase().includes(text?.toLowerCase()) ||
          item.keyword?.toLowerCase().includes(text?.toLowerCase()) ||
          item.seller_name?.toLowerCase().includes(text?.toLowerCase()) ||
          item.prod_code?.toLowerCase().includes(text?.toLowerCase())
        ));
      } else {
        setSortedProducts(products["testPurchase"] || []);
        handleFilter();
      }
    } catch (e) {
      console.error('error in search', e)
    }
  }

  const handleFilter = async () => {
    try {
      let keywordId = list.map((item) => item.id);
      let platformIds = checkedPlatforms.map((item) => item.id);
      let allProducts = products["testPurchase"] || [];
      let kfilter;
      let pfilter;
      let dateSort
      // if (keywordNames.length !== 0) {
      kfilter = allProducts.filter((item) =>
        keywordId?.includes(item.keyword_id)
      )
      console.log("kfilter", kfilter)
      // } else {
      // kfilter = allProducts;
      // }
      // if (platformIds.length !== 0) {
      pfilter = kfilter.filter((item) =>
        platformIds?.includes(item.platform_id)
      )
      console.log("pfilter", pfilter)

      // } else {
      // pfilter = kfilter;
      // }
      let startDate = new Date(dateFilter.startDate);
      let endDate = new Date(dateFilter.endDate);
      //console.log("DATE RANGE", startDate, endDate);

      dateSort = await pfilter.filter((item) => {
        if (item.date_test === undefined) {
          item.date_test = new Date().toLocaleDateString();
        }
        let date = new Date(item.date_test);
        // console.log(date)
        return date >= startDate && date <= endDate;
      })
      console.log("date", dateSort)


      setSortedProducts(dateSort);


    } catch (err) {
      //console.log('error in handleFilter', err)
    }
  }


  useEffect(() => {
    handleFilter();
  }, [list, checkedPlatforms, products["testPurchase"], dateFilter]);






  return (
    <Tabs
      colorScheme="messenger"
      pt={{ base: "180px", md: "80px", xl: "80px" }}
    >
      <TabList>
        <Tab border="transparent">Test Purchase</Tab>
        <Tab border="transparent">Purchase History</Tab>
      </TabList>

      <TabPanels>
        <TabPanel>
          <Box>
            {isLoading && <Loader />}
            {/* Main Fields */}
            <Card p="0px" w="100%">
              <Flex justify={"space-between"} m={2}>

                <Text px="20px" pt="10px">
                  Count: {sortedProducts.length}
                </Text>
                <Flex gap={2}>
                  <IconButton size="md" icon={<MdViewList />} isActive={viewMode === 'list'} onClick={() => setViewMode('list')} />
                  <IconButton size="md" icon={<MdViewModule />} isActive={viewMode === 'grid'} onClick={() => setViewMode('grid')} />

                </Flex>

              </Flex>

              <Flex
                align={{ sm: "flex-start", lg: "center" }}
                justify="space-between"
                w="100%"
                px="22px"
                py="18px"
              >
                <SearchBar
                  m="10px"
                  borderRadius="30px"
                  onChange={(e) => handleSearch(e.target.value)}
                />
                {isAdmin && (

                  <Button
                    variant="action"
                    alignSelf="right"
                    onClick={() => {
                      handleSaveChanges();
                    }}
                  >
                    Save Changes
                  </Button>
                )}
              </Flex>
              <SimpleGrid columns={viewMode === 'grid' ? { base: 1, md: 3, xl: 4 } : 1} spacing={3}>

                {sortedProducts.slice(0, productsToShow).map((prod, index) => {
                  return (
                    <HistoryItem
                      key={index}
                      index={index}
                      product={prod}
                      handleUpdateProduct={handleUpdateProduct}
                      removeFromUpdate={removeProductFromUpdate}
                      handleInsertSeller={handleUpdateSeller}
                      removeFromInsert={removeFromUpdate}
                      handleInsertAbuse={handleInsertAbuse}
                      statusUpdate={statusUpdate}
                      setStatusUpdate={setStatusUpdate}
                      moveProducts={moveProducts}
                      isAdmin={isAdmin}
                      viewMode={viewMode}
                    />
                  );
                })}
              </SimpleGrid>
            </Card>

            <Stack spacing={3} position="fixed" right="10px" bottom="2vh">
              {successAlert !== "" && (
                <Alert status="success" variant="left-accent" w="40vw">
                  <AlertIcon />
                  {successAlert}
                </Alert>
              )}
              {failureAlert !== "" && (
                <Alert status="error" variant="left-accent" w="40vw">
                  <AlertIcon />
                  {failureAlert}
                </Alert>
              )}
            </Stack>

            <Link>
              <Text
                color={textColor}
                fontSize="l"
                fontWeight="500"
                onClick={() => loadLess()}
                r="0"
                position="absolute"
                right={{ base: "10%", md: "15%", sm: "30%" }}
                textDecoration="underline"
              >
                Show less...
              </Text>
            </Link>
            <Link>
              <Text
                color={textColor}
                fontSize="l"
                fontWeight="500"
                onClick={() => loadMore()}
                r="0"
                position="absolute"
                right={{ base: "2%", md: "5%" }}
                textDecoration="underline"
              >
                Show more...
              </Text>
            </Link>

            {/* Delete Product */}
          </Box>
        </TabPanel>

        <TabPanel>
          <PurchaseHistory />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
}
